<template lang="pug">
    el-card(v-loading="loading").chart
        highcharts(:options="chartOptions" :hcInstance="hcInstance")
</template>

<script>
import moment from "moment";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import WritebackCountsQuery from "@/graphql/queries/WritebackCounts";

const timezone = new Date().getTimezoneOffset();

Highcharts.setOptions({
	global: {
		timezoneOffset: timezone
	}
});

export default {
	name: "WritebackChart",

	components: {
		highcharts: Chart
	},

	props: {
		startDate: {
			type: String,
			required: true
		},
		endDate: {
			type: String,
			required: true
		}
	},

	data: () => ({
		loading: true,
		writebacks: [],
		hcInstance: Highcharts
	}),

	watch: {
		$route: {
			handler: "getData",
			immediate: true
		}
	},

	methods: {
		async getData() {
			this.loading = true;

			const response = await this.$apollo.query({
				query: WritebackCountsQuery,
				variables: {
					school: this.$route.params.school,
					type: this.$route.query.type,
					startDate: this.startDate,
					endDate: this.endDate,
					company: this.$route.query.company_id
				},
				fetchPolicy: "cache-first",
				error() {
					this.$message.error("Error loading data. Please try a different date range");
				}
			});

			this.writebacks = response.data.WritebackCounts;

			this.loading = false;
		},
		emptyDates() {
			const dates = [];
			let current = moment(this.startDate);

			while (current.isSameOrBefore(moment(this.endDate))) {
				const date = current
					.clone()
					.startOf("day")
					.valueOf();

				dates.push([date, 0]);

				current.add(1, "days");
			}

			return {
				pending: JSON.parse(JSON.stringify(dates)),
				success: JSON.parse(JSON.stringify(dates)),
				failed: JSON.parse(JSON.stringify(dates))
			};
		},
		calculateTotals() {
			const emptyDates = this.emptyDates();

			const foo = this.writebacks
				.map(wb => {
					return {
						...wb,
						unix: moment(wb.created_at)
							.startOf("day")
							.valueOf()
					};
				})
				.reduce(function(totals, writeback) {
					const index = totals[writeback.status].findIndex(total => total[0] == writeback.unix);

					index === -1 ? totals[writeback.status].push([writeback.unix, 1]) : (totals[writeback.status][index][1] = totals[writeback.status][index][1] + 1);

					return totals;
				}, emptyDates);

			return foo;
		}
	},

	computed: {
		chartOptions() {
			const totals = this.writebacks.length ? this.calculateTotals() : {};

			let statusArray = [
				{
					type: "line",
					data: totals.pending || [],
					name: "Pending",
					color: "#409EFF",
					lineWidth: 3,
					marker: {
						enabled: false
					}
				},
				{
					type: "line",
					data: totals.success || [],
					name: "Success",
					color: "#85b500",
					lineWidth: 3,
					marker: {
						enabled: false
					}
				},
				{
					type: "line",
					data: totals.failed || [],
					name: "Failed",
					color: "#e00d22",
					lineWidth: 3,
					marker: {
						enabled: false
					}
				}
			];

			return {
				title: {
					text: undefined
				},
				chart: {
					type: "line",
					height: 380
				},
				navigator: {
					enabled: false
				},
				rangeSelector: {
					selected: 1
				},
				yAxis: {
					title: {
						text: undefined
					}
				},
				legend: {
					enabled: true
				},
				plotOptions: {
					series: {
						borderRadius: 5,
						pointWidth: 15
					}
				},
				colors: [],
				series: statusArray,
				credits: {
					enabled: false
				},
				xAxis: {
					type: "datetime"
				}
			};
		}
	}
};
</script>
